import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
    const navigate = useNavigate();

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>Payment Successful 🎉</h1>
            <p>Thank you for your support! Your payment was successful.</p>
            <button onClick={() => navigate('/')}>Go Back to Home</button>
        </div>
    );
};

export default PaymentSuccess;

